import { Box, Typography } from "@mui/material"
import CachedIcon from "@mui/icons-material/Cached"
import useTranslation from "hooks/use_translation"

const RotateButton = ({ handleSwitch }) => {
  const { anamnesis } = useTranslation()

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "bg.main",
        mt: 2,
      }}
      onClick={handleSwitch}
    >
      <CachedIcon fontSize="small" />
      <Typography variant="caption" sx={{ ml: 1 }}>
        {anamnesis?.rotate_model}
      </Typography>
    </Box>
  )
}

export default RotateButton
